import React, { PropsWithChildren } from 'react';

type Props = {
  className?: string;
  label?: string;
  type?: 'text' | 'email' | 'search' | '';
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  required?: boolean;
  error?: string | null;
  autoComplete?: string;
};

export const InputText: React.FC<PropsWithChildren<Props>> = ({
  className = '',
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  autoComplete = 'on',
}) => {
  return (
    <>
      {label && (
        <label htmlFor={name} className="cursor-text font-bold">
          {label}
        </label>
      )}

      {/* <input
				className={`w-full mt-1 px-3 py-1.5 text-lg text-gray-500 relative bg-white rounded-md border border-copper/30 outline-none placeholder:text-dark/40 ring-copper focus:ring-2 focus:ring-dark ${className}`}
				type={type ? type : "text"}
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				required={required}
				autoComplete={autoComplete}
			/> */}
      <input
        className={`border-copper/30 placeholder:text-dark/40 ring-copper focus:ring-dark dark:focus:ring-copper dark:text-ivory mt-1 w-full rounded-md border bg-white px-3 py-1.5 text-lg outline-none focus:ring-2 dark:bg-white/5 dark:placeholder:text-white/40 ${error && 'border-2 border-red-500 dark:border-red-500'} ${className}`}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </>
  );
};
